import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import Separator from '../step-landing-page/Separator';
import { Step } from '../views/Step';
import { OAuthToComponent } from './OAuthMapping';
import { OAuthVerificationFailureText } from './OAuthVerificationFailureText';
import { useOAuthSignup } from './useOAuthSignup';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { devices } from '../styles/viewports.styles';
const StyledOAuthContainer = styled.div.withConfig({
  displayName: "OAuthSignupSection__StyledOAuthContainer",
  componentId: "sc-2esyc8-0"
})(["box-shadow:0 4px 20px rgba(81,111,144,0.2);padding-bottom:24px;min-width:340px;@media ", "{min-width:450px;position:relative;left:-10px;}"], devices.desktop);
const StyledSubHeader = styled(FormattedMessage).withConfig({
  displayName: "OAuthSignupSection__StyledSubHeader",
  componentId: "sc-2esyc8-1"
})(["font-size:12px;font-weight:300;text-align:center;display:block;line-height:18px;padding:16px 10px 10px 10px;"]);
const StyledSeperator = styled(FormattedMessage).withConfig({
  displayName: "OAuthSignupSection__StyledSeperator",
  componentId: "sc-2esyc8-2"
})(["font-size:12px;font-weight:300;text-align:center;display:block;line-height:18px;padding-top:20px;"]);
export const OAuthSignupSection = () => {
  const {
    oAuthsEnabledByFlowConfig,
    atLeastOneOAuthEnabled
  } = useOAuthSignup();
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const {
    isAssignedToVariant: isAssignedToVariantACQ0134
  } = useExperiment(ExperimentKeys.ACQ0134, TrackWhen.never);

  const renderOAuths = () => {
    const oAuths = Object.keys(oAuthsEnabledByFlowConfig).filter(oAuth => oAuthsEnabledByFlowConfig[oAuth]).map(oAuth => {
      return /*#__PURE__*/_jsxs("div", {
        children: [OAuthToComponent[oAuth], /*#__PURE__*/_jsx(OAuthVerificationFailureText, {
          oAuth: oAuth
        })]
      }, oAuth);
    });
    return oAuths;
  };

  const renderOAuthSection = () => {
    if (isAssignedToVariantACQ0134()) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs(StyledOAuthContainer, {
          children: [/*#__PURE__*/_jsx(StyledSubHeader, {
            message: "views.LANDING_PAGE.oauthRecommended"
          }), renderOAuths()]
        }), /*#__PURE__*/_jsx(StyledSeperator, {
          message: "views.LANDING_PAGE.orSignupWithEmail"
        })]
      });
    }

    return renderOAuths();
  };

  return /*#__PURE__*/_jsxs("div", {
    className: isFramedCentredStep ? 'm-top-4' : 'm-top-6',
    children: [renderOAuthSection(), atLeastOneOAuthEnabled && !isAssignedToVariantACQ0134() && /*#__PURE__*/_jsx(Separator, {
      message: `views.${Step.LandingPage}.separator`
    })]
  });
};